/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const Dropdown = require('@andes/dropdown');
const { getEventTracker } = require('../../../event-tracker');

const { DropdownItem } = Dropdown;
const { useLiveDemoContext } = require('./Provider/liveDemoContext');

const Language = (props) => {
  const Tracker = getEventTracker();
  const { formData, setFormData } = useLiveDemoContext();
  const { componentProps, liveDemoId, lang, country, i18n } = props;

  function updateState(value) {
    setFormData(prev => ({
      ...prev,
      language: value,
    }));
  }

  return (
    <div className="live-demo-language">
      <Dropdown
        type="form"
        label={i18n.gettext('Idioma')}
        defaultValue={formData?.language ? formData.language : `${lang}-${country}`}
        value={formData?.language ? formData.language : `${lang}-${country}`}
        onChange={(event, value) => {
          Tracker.send(`mp_developers-test/live_demo/change_${liveDemoId}_select_language`, value);
          updateState(value);
        }}
      >
        {componentProps?.languages?.map((item) => (
          <DropdownItem key={item?.value} value={item?.value} title={item?.description} />
        ))}
      </Dropdown>
    </div>
  );
};

module.exports = Language;
